import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { retrieveStockAll } from "../../Services/StockSessionApiService";
import { useEffect } from "react";
import { useState } from "react";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import {
  retrieveSetting,
  updateSetting,
} from "../../Services/SettingApiService";
import { useRef } from "react";
import { useAuthHeader } from "../../auth/AuthService";

export default function Setting() {
  const { t } = useTranslation();
  const authHeader = useAuthHeader();

  const [stock, setStock] = useState([]);
  const [setting, setSetting] = useState();
  const toast = useRef(null);

  // Setting Type 1
  const [rotation1, setRotation1] = useState();
  const [language1, setLanguage1] = useState();
  const [stock1, setStock1] = useState();
  const [selectStock, setSelectStock] = useState(null);
  const [currencyType, setCurrencyType] = useState(1);

  const rotationTypes1 = [
    { name: t("No Rotation"), value: 0 },
    { name: t("Language Rotation"), value: 1 },
    { name: t("Stock Rotation"), value: 2 },
  ];
  const languageTypes1 = [
    { name: t("English"), value: "eng" },
    { name: t("Khmer"), value: "cat" },
  ];
  const currencyTypes = [
    { name: "KHR", value: 1 },
    { name: "USD", value: 2 },
  ];

  // Setting Type 2
  const [rotation2, setRotation2] = useState();
  const [board2, setBoard2] = useState();
  const [language2, setLanguage2] = useState();

  const rotationTypes2 = [
    { name: t("No"), value: 0 },
    { name: t("Yes"), value: 1 },
  ];
  const boardTypes2 = [
    { name: t("Main Board"), value: "M" },
    { name: t("Growth Board"), value: "G" },
  ];

  // Setting Type 3
  const [language3, setLanguage3] = useState();

  // Rotation
  const [rotation, setRotation] = useState();

  async function init() {
    await retrieveStockAll(authHeader())
      .then((response) => {
        let data = response.data.data;
        let arr = [];
        Object.keys(data).map((icode, i) => {
          arr.push({ name: data[icode], value: icode });
        });
        setStock(arr);
      })
      .catch((error) => console.log(error));

    await retrieveSetting(authHeader())
      .then((response) => {
        let data = response.data.data;
        setSetting(data);
        setRotation1(data?.type);
        setLanguage1(data?.language);

        data?.type != 2
          ? setStock1(data?.stock)
          : setSelectStock(data?.stock.split(":"));

        setRotation2(data?.type1);
        setBoard2(data?.boardType);
        setLanguage2(data?.language1);
        setCurrencyType(data?.currencyType);
        setLanguage3(data?.language2);
        setRotation(data?.rotationDelay);
      })
      .catch((error) => console.log(error));
  }

  const languages = [
    { name: t("English"), value: "eng" },
    { name: t("Khmer"), value: "cat" },
  ];

  const marketRotations = [{ name: t("All"), value: 2 }];

  async function submitSetting() {
    const settingData = {
      type: rotation1,
      type1: rotation2,
      type2: 2,
      language: language1,
      language1: language2,
      language2: language3,
      stock: rotation1 == 2 ? selectStock.join(":") : stock1,
      boardType: board2,
      rotationDelay: rotation,
      currencyType: currencyType,
    };

    await updateSetting(setting.id, settingData, authHeader())
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Success!",
          detail: "Your setting is successfully updated",
          life: 3000,
        });
      })
      .catch((error) =>
        toast.current.show({
          severity: "error",
          summary: "Error!",
          detail: "Something went wrong",
          life: 3000,
        })
      );
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="relative h-full">
      <div className="flex justify-content-center pt-7">
        <div className="flex w-11 lg:w-9 justify-content-center">
          <div className="grid w-full">
            <div className="col-12">
              {/* Title */}
              <div className="text-3xl font-bold mb-4">
                Favorite Stock Setting
              </div>

              {/* Screen 1 Setting */}
              <div className="col-12 mb-4">
                <div className="card p-3 shadow-6 border-round-lg bg-card">
                  <div className="grid align-items-center">
                    <div className="col-12 text-xl font-bold">
                      Screen 1 Setting
                    </div>
                    <div className="col-6 md:col-3">
                      <label htmlFor="type1rotation" className="pl-1 text-sm">
                        Rotation Type:
                      </label>
                      <Dropdown
                        id="type1rotation"
                        value={rotation1}
                        onChange={(e) => setRotation1(e.value)}
                        options={rotationTypes1}
                        optionLabel="name"
                        placeholder="Select a Rotation Type"
                        className="w-full border-round-lg"
                      />
                    </div>
                    {rotation1 != 1 && (
                      <div className="col-6 md:col-3">
                        <label htmlFor="type1language" className="pl-1 text-sm">
                          Language:
                        </label>
                        <Dropdown
                          id="type1language"
                          value={language1}
                          onChange={(e) => setLanguage1(e.value)}
                          options={languageTypes1}
                          optionLabel="name"
                          placeholder="Select a Language"
                          className="w-full border-round-lg"
                        />
                      </div>
                    )}
                    {rotation1 == 2 && (
                      <div className="col-6 md:col-3">
                        <label htmlFor="type1stock" className="pl-1 text-sm">
                          Stock:
                        </label>
                        <MultiSelect
                          value={selectStock}
                          onChange={(e) => setSelectStock(e.value)}
                          options={stock}
                          optionLabel="name"
                          display="chip"
                          placeholder="Select Stocks"
                          className="w-full border-round-lg"
                        />
                      </div>
                    )}
                    {rotation1 != 2 && (
                      <div className="col-6 md:col-3">
                        <label htmlFor="type1stock" className="pl-1 text-sm">
                          Stock:
                        </label>
                        <Dropdown
                          id="type1stock"
                          value={stock1}
                          onChange={(e) => setStock1(e.value)}
                          options={stock}
                          optionLabel="name"
                          placeholder="Select a Stock"
                          className="w-full border-round-lg"
                        />
                      </div>
                    )}
                    <div className="col-6 md:col-3">
                      <label htmlFor="type1stock" className="pl-1 text-sm">
                        Currency Type:
                      </label>
                      <Dropdown
                        id="type1stock"
                        value={currencyType}
                        onChange={(e) => setCurrencyType(e.value)}
                        options={currencyTypes}
                        optionLabel="name"
                        placeholder="Select a Stock"
                        className="w-full border-round-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 mb-4">
                <div className="card p-3 shadow-6 border-round-lg bg-card">
                  <div className="grid align-items-center">
                    <div className="col-12 text-xl font-bold">
                      Screen 2 Setting
                    </div>
                    <div className="col-6 md:col-3">
                      <label htmlFor="type2rotation" className="pl-1 text-sm">
                        Rotation Board:
                      </label>
                      <Dropdown
                        id="type2rotation"
                        value={rotation2}
                        onChange={(e) => setRotation2(e.value)}
                        options={rotationTypes2}
                        optionLabel="name"
                        placeholder="Select a Rotations"
                        className="w-full border-round-lg"
                      />
                    </div>
                    {rotation2 != 1 && (
                      <div className="col-6 md:col-3">
                        <label htmlFor="type2market" className="pl-1 text-sm">
                          Market:
                        </label>
                        <Dropdown
                          id="type2market"
                          value={board2}
                          onChange={(e) => setBoard2(e.value)}
                          options={boardTypes2}
                          optionLabel="name"
                          placeholder="Select a Stock"
                          className="w-full border-round-lg"
                        />
                      </div>
                    )}
                    <div className="col-6 md:col-3">
                      <label htmlFor="type2language" className="pl-1 text-sm">
                        Language:
                      </label>
                      <Dropdown
                        id="type2language"
                        value={language2}
                        onChange={(e) => setLanguage2(e.value)}
                        options={languages}
                        optionLabel="name"
                        placeholder="Select a Language"
                        className="w-full border-round-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Screen 3 Setting */}
              <div className="col-12 mb-4">
                <div className="card p-3 shadow-6 border-round-lg bg-card">
                  <div className="grid align-items-center">
                    <div className="col-12 text-xl font-bold">
                      Screen 3 Setting
                    </div>
                    <div className="col-6 md:col-3">
                      <label htmlFor="type3market" className="pl-1 text-sm">
                        Market:
                      </label>
                      <Dropdown
                        id="type3market"
                        value={2}
                        onChange={() => {}}
                        options={marketRotations}
                        optionLabel="name"
                        placeholder="Select a Stock"
                        className="w-full border-round-lg"
                      />
                    </div>
                    <div className="col-6 md:col-3">
                      <label htmlFor="type3language" className="pl-1 text-sm">
                        Language:
                      </label>
                      <Dropdown
                        id="type3language"
                        value={language3}
                        onChange={(e) => setLanguage3(e.value)}
                        options={languages}
                        optionLabel="name"
                        placeholder="Select a Language"
                        className="w-full border-round-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Rotation Setting */}
              <div className="col-12 mb-3">
                <div className="card p-3 shadow-6 border-round-lg bg-card">
                  <div className="grid align-items-center">
                    <div className="col-12 text-xl font-bold">
                      Rotation Setting
                    </div>
                    <div className="col-6 md:col-3">
                      <label htmlFor="username" className="pl-1 text-sm">
                        Rotation Delay (seconds):
                      </label>
                      <InputNumber
                        id="username"
                        value={rotation}
                        onChange={(e) => setRotation(e.value)}
                        inputClassName="border-round-lg"
                        max={100}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-12">
                <Toast ref={toast} />
                <Button
                  type="submit"
                  onClick={submitSetting}
                  label="Submit"
                  className="bg-white text-blue-900 border-round-sm"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
